import ApiProvider from "./ApiProvider"
import Venue from '../models/Venue'

export default class VenueProvider extends ApiProvider {
    static readonly fields = [
        'title',
        'venue_group',
        'location',
        'offers',
        'building_name',
        'street',
        'city',
        'postcode',
        'booking_types',
        'offers',
        'opening_times'
    ]

    requestVenuesFromCache (venueHash:string) : Venue[] | null {
      const venueCacheKey = 'dmn_bw_venues_' + venueHash
      const venuelastCachedKey = 'dmn_bw_venues_last_cached_at_' + venueHash

      try {
        if (localStorage && localStorage.getItem(venueCacheKey) && localStorage.getItem(venuelastCachedKey)) {
          const secsSinceCache = (Date.now() - parseInt(localStorage.getItem(venuelastCachedKey) || '0')) / 1000
          const fiveMins = 300

          if (secsSinceCache < fiveMins) {
            return JSON.parse(localStorage.getItem(venueCacheKey) || '{}').map((venueOrig: any): Venue => {
              return Object.assign(new Venue([]), venueOrig)
            })
          }
        }
      } catch(e) {
        console.error('Could not load venue from local storage')
        this.removeAllDMNCachedItems()
      }

      return null
    }

    removeAllExpiredItems() {
      if (!localStorage) {
        return
      }

      try {
        let expiredKeys: string[] = []

        for (var i = 0; i < localStorage.length; i++){
          if (localStorage.key(i)?.substring(0,29) === 'dmn_bw_venues_last_cached_at_') {
            const secsSinceCache = (Date.now() - parseInt(localStorage.getItem(localStorage.key(i) || '') || '0')) / 1000
            const fiveMins = 300

            if (secsSinceCache > fiveMins) {
              const expiredHash = localStorage.key(i)?.substring(29)
              expiredKeys.push('dmn_bw_venues_last_cached_at_' + expiredHash)
              expiredKeys.push('dmn_bw_venues_' + expiredHash)
            }
          }
        }

        for (var i = 0; i < expiredKeys.length; i++) {
          localStorage.removeItem(expiredKeys[i])
        }
      } catch(e) {
        console.error('Could not remove expired items from local storage')
      }
    }

    getVenueHash(venuesIds: string[]) {
      return (venuesIds.map((venueId) => venueId.slice(venueId.length - 4))).join('')
    }

    cacheVenues (venues: Venue[]) {
      if (!localStorage) {
        return null
      }

      try {
        const venueIds = venues.map((venue) => venue.id)
        const venueCacheKey = 'dmn_bw_venues_' + this.getVenueHash(venueIds)
        const venuelastCachedKey = 'dmn_bw_venues_last_cached_at_' + this.getVenueHash(venueIds)

        localStorage.setItem(venueCacheKey, JSON.stringify(venues))
        localStorage.setItem(venuelastCachedKey, Date.now() + '')
      } catch(e) {
        console.error('Could not create venues in local storage')
        this.removeAllDMNCachedItems()
      }
    }

    removeAllDMNCachedItems() {
      if (!localStorage) {
        return
      }

      try {
        let dmnKeys: string[] = []

        for (var i = 0; i < localStorage.length; i++){
          if (localStorage.key(i)?.substring(0,14) === 'dmn_bw_venues_') {
            dmnKeys.push(localStorage.key(i) || '')
          }
        }

        for (var i = 0; i < dmnKeys.length; i++) {
          localStorage.removeItem(dmnKeys[i])
        }
      } catch(e) {}
    }

    requestVenues (venueIds: string[]): Promise<Venue[]> {
        const url = this._buildUrl(venueIds)
        const params = this.objToParams({
            fields: VenueProvider.fields.join(',')
        })

        const requestUrl = url + params

        return this.get(requestUrl, {withCredentials: true})
            .then((response) => {
                const payload = response.data.payload
                let venues: Venue[] = []

                if (Array.isArray(payload)) {
                    payload.forEach((venue) => {
                        if (Venue.isValid(venue)) {
                            venues.push(new Venue(venue))
                        }
                    })
                } else {
                    if (Venue.isValid(payload.venue)) {
                        venues.push(new Venue(payload.venue))
                    }
                }

                return venues
            })
    }

    _buildUrl (venueIds: string[]): string {
        return [
            this.baseUrl,
            'venues',
            venueIds.join(',')
        ].join('/')
    }
}



// WEBPACK FOOTER //
// ./src/services/VenueProvider.ts